export default "__VITE_ASSET__2b587a85__"